import { Navigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import AuthFlow from '@/components/AuthFlow';
import SEOHead from '@/components/SEOHead';

const Auth = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user) {
    return <Navigate to="/account/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <SEOHead page="auth" />
      <div className="w-full max-w-md">
        <Card className="border-border bg-card shadow-lg">
          <CardContent className="p-8">
            <AuthFlow onSuccess={() => navigate('/account/dashboard')} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Auth;
